import { Box, Typography } from "@mui/material";
import GoogleCalendar from "../GoogleCalendar";
import EventsGrid from "../EventsGrid";

export const Events = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '20px',
            }}
        >
            <Typography variant="h4" color="text.primary" gutterBottom>
                Events
            </Typography>
            <GoogleCalendar />
            <EventsGrid />
        </Box>
    );
}